export default [
  { id: 'year', text: 'Ano' },
  { id: 'month', text: 'Mês' },
  { id: 'day', text: 'Dia' },
  { id: 'hour', text: 'Hora' },
  { id: 'minute', text: 'Minuto(s):' }
];
